import { ErrorHandler, Injectable } from '@angular/core';
import { mapUnknownError } from './app-error-catalog';
import { LoggerService } from './logger.service';
import { NotificationFacadeService } from './notification-facade.service';

@Injectable()

/**
 * Final safety net for uncaught runtime errors.
 *
 * The handler converts unexpected exceptions into the shared AppError contract so
 * the rest of the application can treat runtime failures the same way as HTTP or
 * component-level operational failures.
 */
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private logger: LoggerService,
    private notificationFacade: NotificationFacadeService
  ) {
  }

  /**
   * Normalizes, logs, and conditionally presents uncaught runtime failures.
   */
  handleError(error: unknown): void {
    const appError = mapUnknownError(error, 'global-error-handler');
    this.logger.error(appError);
    this.notificationFacade.showError(appError);
  }
}